import {
    Component,
    EventEmitter,
    inject,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { Paging } from '@wdx/clmi/api-services/models';
import { Activity, SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import { PartyToAvatarPipe } from '@wdx/clmi/utils/pipes';
import { EntityRouteService } from '@wdx/clmi/utils/services';
import { INBOX_FILTER_FORM_ID } from '@wdx/shared/utils';
import { FilterHandler } from '../../../classes/filter-handler.class';
import { ActionButton } from '../../../models/action-button.model';
import { CardType } from '../../../models/card-type.model';
import { ListItem } from '../../../models/list-item.model';
import { ScrollMode } from '../../../models/scroll-mode.model';
import { ToDoItem } from '../../../models/to-do-item.model';
import { RandomStringPipe } from '../../../pipes/random-string.pipe';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'organism-activities-list',
    templateUrl: './organism-activities-list.component.html',
    standalone: false,
})
export class OrganismActivitiesListComponent implements OnInit {
    @Input() activities: Activity[];
    @Input() activitiesPaging: Paging;
    @Input() isLoading: boolean;
    @Input() hasError: boolean;
    @Input() filterHandler: FilterHandler;
    @Input() activitiesPerRow: number;
    @Input() activityCreateActionButton: ActionButton;
    @Input() showFilters: boolean;
    @Input() showFilterBar = true;
    @Input() showSearchBar = true;
    @Input() showFavourite = false;
    @Input() scrollMode: ScrollMode;
    @Input() searchType = 'Activity';
    @Input() searchTypePlural = 'Activities';
    @Input() totalRecordCount: number;
    @Input() limit: number;
    @Input() addWidgetContainerPadding: boolean;

    @Output() infinityScrollFired = new EventEmitter();

    readonly INBOX_FILTER_FORM = INBOX_FILTER_FORM_ID;

    instanceId: string;

    cardType = CardType.Activity;
    filtersModalId = 'activities-list-filter';

    protected entityRouteService = inject(EntityRouteService);

    ngOnInit() {
        this.instanceId = new RandomStringPipe().transform();
        this.filtersModalId = new RandomStringPipe().transform();
    }

    onSearch(value: string): void {
        this.filterHandler.setSearchText(value);
    }

    activitiesAsToDoItems(
        activities: Activity[],
        entityRouteService: EntityRouteService,
    ): ToDoItem[] {
        return activities
            ? activities.map((activity): ToDoItem => {
                  return {
                      id: activity.id,
                      data: activity,
                      primaryInfo: activity.subject,
                      dueDate: new Date(activity.due),
                      tags: activity.tags?.length,
                      filedUnder: activity.regarding
                          ? activity.regarding.map((regarding) => {
                                return {
                                    label: regarding.name ?? regarding.type,
                                    data: regarding,
                                } as ListItem;
                            })
                          : [],
                      activityType: activity.activityType,
                      attachments: activity.files?.length,
                      avatars: activity.activityParties.map((activityParty) =>
                          new PartyToAvatarPipe().transform(
                              activityParty.party || activityParty.contactPoint,
                          ),
                      ),
                      remindDate: activity.reminders?.length
                          ? new Date(activity.reminders[0].dateReminder)
                          : null,
                      content: activity.content,
                      status: activity.status,
                      routingLink:
                          entityRouteService.routeWithParamsForEntity(
                              SystemEntity.Activity,
                              activity.id,
                          ),
                  };
              })
            : [];
    }

    onInfinityScrollFired(): void {
        this.infinityScrollFired.emit();
    }
}
